export function detectBrowser() {
  const ua = navigator.userAgent || "";

  if (/firefox|fxios/i.test(ua)) {
    return "Firefox";
  }

  if (
    /chrome|crios/i.test(ua) &&
    !/edg|edge|edgios|edga|opr|opera|opios/i.test(ua)
  ) {
    return "Chrome";
  }

  if (/edg|edge|edgios|edga/i.test(ua)) {
    return "Edge";
  }

  if (/opr|opera|opios/i.test(ua)) {
    return "Opera";
  }

  if (
    /safari/i.test(ua) &&
    !/chrome|crios|fxios|edg|edge|opr|opera/i.test(ua)
  ) {
    return "Safari";
  }

  return "Unknown browser";
}